/**
 * @generated SignedSource<<c6ad1e5f2b868229835df639e1e40f2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogoutPayload",
    "kind": "LinkedField",
    "name": "logout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsModalQuery_logoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsModalQuery_logoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6613c7eb8a77c7147ca86215330fc9c1",
    "id": null,
    "metadata": {},
    "name": "SettingsModalQuery_logoutMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsModalQuery_logoutMutation(\n  $input: LogoutInput!\n) {\n  logout(input: $input) {\n    ok\n    error {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "038513f76fbd4dc1579eaebc29f26f72";

module.exports = node;
